//libs
import { createRouter, createWebHashHistory } from "vue-router";
import { pushMatomoEvent } from "@/helpers/matomo";
import { normalizeRouteContext } from "@/helpers/entrySource";

//vues: pages authentifiées
import Home from "../views/Home.vue";
import MissingParameters from "../views/MissingParameters.vue";

const routes = [
  {
    path: "/:clientCode/:source?/:regimeType?",
    name: "Home",
    meta: { layout: "DefaultLayout", title: "Accueil", crumbs: [] },
    component: Home,
  },
  {
    path: "/missing-parameters",
    name: "MissingParameters",
    meta: { layout: "EmptyLayout", title: "Paramètres manquants", crumbs: [] },
    component: MissingParameters,
  },
  {
    path: "/",
    redirect: "/missing-parameters",
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Validation des paramètres pour la route Home
  if (to.name === "Home") {
    const clientCode = to.params.clientCode;

    if (!clientCode) {
      next({ name: "MissingParameters" });
      return;
    }
  }

  next();
});

router.afterEach((to) => {
  const routeContext = normalizeRouteContext(to.params);

  if (to.meta.title) {
    document.title = to.meta.title + " | Simulateur de garanties santé";
  } else {
    document.title = "Simulateur de garanties santé";
  }

  pushMatomoEvent("page_view", {
    page_title: to.meta.title || "Simulateur de garanties santé",
    page_name: to.name || "unknown",
    page_path: to.fullPath,
    source_entree: routeContext.sourceEntree,
  });
});

export default router;
